
export enum FilterVariablesType {
    DateFilter = 0,
    UserFilter = 1
}
